<script setup>
import {watch} from "vue";
import {ElNotification} from "element-plus";
import {useStore} from "@/store/store";
const store = useStore()


watch(
  () => store.messages.slice(), // следим за копией, чтобы отловить push
  (newMessages, oldMessages) => {
    if (newMessages.length > oldMessages.length) {
      const last = newMessages[newMessages.length - 1]
      if (last) {
        ElNotification({
          title: 'Уведомление',
          message: last?.message || "Нет сообщения",
          type: last?.style || 'error', // можно: success, warning, error, info
          duration: (last?.duraction_sec || 10) * 1000,
          position: 'bottom-right',
        })
      }
    }
  },
  { deep: true }
)
</script>

<template></template>